// 白名单
const whitePath: string[] = [
  '/user/Login/Login',
  '/user/WebView/Index',
  '/user/Setting/WebView/Index',
  '/user/Setting/WebView/Index',
  '/whitePath/DownloadGuide/Index',
  '/whitePath/AuthorizedLogin/Index',
  '/whitePath/StoreRecruitRegister/Index',
  '/whitePath/UserRecruitRegister/Index',
];

// 登录页
const loginPath: string = '/user/Login/Login';

export const initPermission = (): void => {
  const list = ["navigateTo", "redirectTo", "reLaunch", "switchTab"];
  list.forEach(item => { //用遍历的方式分别为,uni.navigateTo,uni.redirectTo,uni.reLaunch,uni.switchTab这4个路由方法添加拦截器
    uni.addInterceptor(item, {
      invoke(e) { // 调用前拦截
        //获取用户的token
        const token: string = uni.getStorageSync('token');
        const url:string = e.url.split('?')[0];
        const notNeed:boolean = whitePath.includes(url)
        // 如果在whitePath里面就不需要登录
        if (notNeed) {
          return e
        } else {

          //跳过token验证
          // return e;

          /**
           * token,就跳转到登录页
           */
          if (!token) {
            uni.showToast({
              title: '请先登录',
              icon: 'none'
            })
            uni.navigateTo({
              url: loginPath
            })
            return false
          } else {
            return e
          }
        }
      },
      fail(err) { // 失败回调拦截
        console.log(err);
      }
    })
  })
}
